import { Component, Input } from '@angular/core';

import { NgClass } from '@angular/common';
import { CommonColors } from '@inscomponents/core';
import { TooltipDirective } from '../../tooltip/tooltip.directive';

@Component({
    selector: 'skl-validation-icon',
    templateUrl: './validation-icon.component.html',
    imports: [NgClass, TooltipDirective]
})
export class ValidationIconComponent {
    @Input() public violation!: CommonColors;
    @Input() public messages!: string[];

    public constructor() {}

    public getValidationClassName(): string {
        return `validation-icon-new--${this.violation}`;
    }
}
